import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import styled from "@mui/material/styles/styled";
const DetailStyle = styled(ListItem)(() => {
    return {
        fontFamily: "Roboto",
        ".MuiListItemText-primary": {
            whiteSpace: 'pre-wrap',
            letterSpacing: 1.12,
            fontSize: 14,
            marginBottom: 2
        },
        ".MuiListItemText-secondary": {
            fontSize: 16,
            fontWeight: 700,
            color: "#000",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.1,
            letterSpacing: "normal",
        },
        ".MuiListItem-root:hover": {
            background: "#fff !important",
            color: "initial !important",
        },
    };
});
export const Detail = (props) => {
    var _a;
    return (React.createElement(List, null, (_a = props.list) === null || _a === void 0 ? void 0 : _a.map((data) => (React.createElement(DetailStyle, { key: data.title },
        React.createElement(ListItemText, { primary: data.title, secondary: data.subTitle || "" }))))));
};
